const MockTermConstants = {

    /*
     * List of the dates that have a matching set of mock terms.
     *
     * It is expected that the index of the date in this array will match the index for the data in MOCK_TERM_SET
     */
    MOCK_DATES: [
        "04/13/2018",
        "05/04/2018",
        "05/04/2018",
        "06/18/2018",
        "09/26/2018",
        "09/29/2018",
        "10/16/2018",
        "10/23/2018",
        "12/15/2018",
        "10/12/2018",
        "11/02/2018",
        "11/02/2018",
        "11/19/2018",
        "01/07/2019",
        "01/14/2019",
        "01/27/2019",
        "03/12/2019",
        "03/24/2019",
        "01/18/2019",
        "02/15/2019",
        "02/15/2019",
        "03/04/2019",
        "04/01/2019",
        "04/01/2018",
        "04/21/2019",
        "06/10/2019",
        "06/23/2019",
        "02/01/2019",
        "04/15/2019",
        "04/15/2019",
        "05/23/2019",
        "06/24/2019",
        "06/27/2019",
        "07/09/2019",
        "07/31/2019",
        "09/01/2019"
    ],

    /*
     * Set of mock data for term stores for each identified significant date in an academic year.
     *
     */
    MOCK_TERM_SET: [
        {
            "date" : "04/13/2018 12:00",
            "current" : "20182",
            "plannable" : [ "20182", "20183", "20184" ],
            "label" : "Autumn 2018 Time Schedule Publish"
        }, {
            "date" : "05/04/2018 4:59",
            "current" : "20182",
            "plannable" : [ "20183", "20184" ],
            "label" : "Autumn 2018 Before P1 Opens"
        }, {
            "date" : "05/04/2018 5:00",
            "current" : "20182",
            "plannable" : [ "20183", "20184" ],
            "label" : "Autumn 2018 After P1 Opens"
        }, {
            "date" : "06/18/2018 12:00",
            "current" : "20183",
            "plannable" : [ "20183", "20184" ],
            "label" : "Autumn 2018 P2 Opens"
        }, {
            "date" : "09/26/2018 12:00",
            "current" : "20184",
            "plannable" : [ "20184" ],
            "label" : "Autumn 2018 P3 Opens / 1st Day instruction"
        }, {
            "date" : "09/29/2018 12:00",
            "current" : "20184",
            "plannable" : [ "20184" ],
            "label" : "Autumn 2018 Week 1 of Term"
        }, {
            "date" : "10/16/2018 12:00",
            "current" : "20184",
            "plannable" : [ "20184", "20191" ],
            "label" : "Autumn 2018 Last Add Day"
        }, {
            "date" : "10/23/2018 12:00",
            "current" : "20184",
            "plannable" : [ "20191" ],
            "label" : "Autumn 2018 Week 5 of Term"
        }, {
            "date" : "12/15/2018 12:00",
            "current" : "20184",
            "plannable" : [ "20191" ],
            "label" : "Autumn 2018 Winter Break"
        }, {
            "date" : "10/12/2018 12:00",
            "current" : "20184",
            "plannable" : [ "20191" ],
            "label" : "Winter 2019 Time Schedule Publish"
        }, {
            "date" : "11/02/2018 4:59",
            "current" : "20184",
            "plannable" : [ "20191" ],
            "label" : "Winter 2019 Before P1 Opens"
        }, {
            "date" : "11/02/2018 5:00",
            "current" : "20184",
            "plannable" : [ "20191" ],
            "label" : "Winter 2019 After P1 Opens"
        }, {
            "date" : "11/19/2018 12:00",
            "current" : "20184",
            "plannable" : [ "20191" ],
            "label" : "Winter 2019 P2 Opens"
        }, {
            "date" : "01/07/2019 12:00",
            "current" : "20191",
            "plannable" : [ "20191" ],
            "label" : "Winter 2019 P3 Opens/ 1st Day instruction"
        }, {
            "date" : "01/14/2019 12:00",
            "current" : "20191",
            "plannable" : [ "20191" ],
            "label" : "Winter 2019 Week 2 of Term"
        }, {
            "date" : "01/27/2019 12:00",
            "current" : "20191",
            "plannable" : [ "20191", "20192" ],
            "label" : "Winter 2019 Last Add Day"
        }, {
            "date" : "03/12/2019 12:00",
            "current" : "20191",
            "plannable" : [ "20192" ],
            "label" : "Winter 2019 Week 10 of Term"
        }, {
            "date" : "03/24/2019 12:00",
            "current" : "20191",
            "plannable" : [ "20192" ],
            "label" : "Winter 2019 Spring Break"
        }, {
            "date" : "01/18/2019 12:00",
            "current" : "20191",
            "plannable" : [ "20192" ],
            "label" : "Spring 2019 Time Schedule Publish"
        }, {
            "date" : "02/15/2019 4:59",
            "current" : "20191",
            "plannable" : [ "20192", "20193" ],
            "label" : "Spring 2019 Before P1 Opens"
        }, {
            "date" : "02/15/2019 5:00",
            "current" : "20191",
            "plannable" : [ "20192", "20193" ],
            "label" : "Spring 2019 After P1 Opens"
        }, {
            "date" : "03/04/2019 12:00",
            "current" : "20191",
            "plannable" : [ "20192", "20193" ],
            "label" : "Spring 2019 P2 Opens"
        }, {
            "date" : "04/01/2019 12:00",
            "current" : "20192",
            "plannable" : [ "20192", "20193" ],
            "label" : "Spring 2019 P3 Opens/ 1st Day instruction"
        }, {
            "date" : "04/01/2018 12:00",
            "current" : "20192",
            "plannable" : [ "20192", "20193" ],
            "label" : "Spring 2019 Week 1 of Term"
        }, {
            "date" : "04/21/2019 12:00",
            "current" : "20192",
            "plannable" : [ "20192", "20193" ],
            "label" : "Spring 2019 Last Add Day"
        }, {
            "date" : "06/10/2019 12:00",
            "current" : "20192",
            "plannable" : [ "20193" ],
            "label" : "Spring 2019 Finals Week"
        }, {
            "date" : "06/23/2019 12:00",
            "current" : "20192",
            "plannable" : [ "20193" ],
            "label" : "Spring 2019 Summer Break"
        }, {
            "date" : "02/01/2019 12:00",
            "current" : "20192",
            "plannable" : [ "20193" ],
            "label" : "Summer 2019 Time Schedule Publish"
        }, {
            "date" : "04/15/2019 4:59",
            "current" : "20192",
            "plannable" : [ "20193", "20194" ],
            "label" : "Summer 2019 Before P1 Opens"
        }, {
            "date" : "04/15/2019 5:00",
            "current" : "20192",
            "plannable" : [ "20193", "20194" ],
            "label" : "Summer 2019 After P1 Opens"
        }, {
            "date" : "05/23/2019 12:00",
            "current" : "20192",
            "plannable" : [ "20193", "20194" ],
            "label" : "Summer 2019 P2 Opens"
        }, {
            "date" : "06/24/2019 12:00",
            "current" : "20193",
            "plannable" : [ "20193", "20194" ],
            "label" : "Summer 2019 P3 Opens/ 1st Day instruction"
        }, {
            "date" : "06/27/2019 12:00",
            "current" : "20193",
            "plannable" : [ "20193", "20194" ],
            "label" : "Summer 2019 Week 1 of Term"
        }, {
            "date" : "07/09/2019 12:00",
            "current" : "20193",
            "plannable" : [ "20193", "20194" ],
            "label" : "Summer 2019 Week 3 of Term"
        }, {
            "date" : "07/31/2019 12:00",
            "current" : "20193",
            "plannable" : [ "20193", "20194" ],
            "label" : "Summer 2019 Last Add Day (B Term)"
        }, {
            "date" : "09/01/2019 12:00",
            "current" : "20193",
            "plannable" : [ "20194" ],
            "label" : "Summer 2019 Autumn Break"
        }
    ],

    /*
     * Set of pre-fetched Term payloads from the MyPlan svcs-common TermController.
     *
     * These were fetched on 11/30/2018
     */
    MOCK_TERM_PAYLOADS: {
        "20182": {
            "year": "2018",
            "code": "2",
            "id": "20182",
            "codeName": "Spring",
            "name": "Spring 2018",
            "qtrYearParam": "SPR+2018",
            "shortName": "SP 18",
            "shortNameFullYear": "SP 2018",
            "subTerms": [],
            "currentWeek": 0,
            "maxWeeks": 10,
            "academicCalendar": [
                {
                    "key": "RegistrationServicesStart",
                    "dateDisplay": "February 2",
                    "date": "2018-02-02",
                    "range": false,
                    "endDate": ""
                },
                {
                    "key": "FirstRegistrationPeriod",
                    "dateDisplay": "February 9 - February 25",
                    "date": "2018-02-09",
                    "range": true,
                    "endDate": "2018-02-25"
                },
                {
                    "key": "SecondRegistrationPeriod",
                    "dateDisplay": "February 26 - March 25",
                    "date": "2018-02-26",
                    "range": true,
                    "endDate": "2018-03-25"
                },
                {
                    "key": "FirstDay",
                    "dateDisplay": "March 26",
                    "date": "2018-03-26",
                    "range": false,
                    "endDate": ""
                },
                {
                    "key": "ThirdRegistrationPeriod",
                    "dateDisplay": "March 26 - April 1",
                    "date": "2018-03-26",
                    "range": true,
                    "endDate": "2018-04-01"
                },
                {
                    "key": "FifthDay",
                    "dateDisplay": "March 30",
                    "date": "2018-03-30",
                    "range": false,
                    "endDate": ""
                },
                {
                    "key": "CensusDay",
                    "dateDisplay": "April 6",
                    "date": "2018-04-06",
                    "range": false,
                    "endDate": ""
                },
                {
                    "key": "LastDropDayNotRecorded",
                    "dateDisplay": "April 8",
                    "date": "2018-04-08",
                    "range": false,
                    "endDate": ""
                },
                {
                    "key": "last_add_day",
                    "dateDisplay": "April 15",
                    "date": "2018-04-15",
                    "range": false,
                    "endDate": ""
                },
                {
                    "key": "LastDropDay",
                    "dateDisplay": "May 13",
                    "date": "2018-05-13",
                    "range": false,
                    "endDate": ""
                },
                {
                    "key": "LastDayOfClasses",
                    "dateDisplay": "June 1",
                    "date": "2018-06-01",
                    "range": false,
                    "endDate": ""
                },
                {
                    "key": "LastFinalExamDay",
                    "dateDisplay": "June 8",
                    "date": "2018-06-08",
                    "range": false,
                    "endDate": ""
                }
            ],
            "numericYear": 2018,
            "characterCode": "",
            "numericCode": 2
        },
        "20183": {
            "year": "2018",
            "code": "3",
            "id": "20183",
            "codeName": "Summer",
            "name": "Summer 2018",
            "qtrYearParam": "SUM+2018",
            "shortName": "SU 18",
            "shortNameFullYear": "SU 2018",
            "subTerms": [],
            "currentWeek": 0,
            "maxWeeks": 10,
            "academicCalendar": [
                {
                    "key": "RegistrationServicesStart",
                    "dateDisplay": "April 2",
                    "date": "2018-04-02",
                    "range": false,
                    "endDate": ""
                },
                {
                    "key": "FirstRegistrationPeriod",
                    "dateDisplay": "April 9 - May 16",
                    "date": "2018-04-09",
                    "range": true,
                    "endDate": "2018-05-16"
                },
                {
                    "key": "SecondRegistrationPeriod",
                    "dateDisplay": "May 17 - June 17",
                    "date": "2018-05-17",
                    "range": true,
                    "endDate": "2018-06-17"
                },
                {
                    "key": "FirstDay",
                    "dateDisplay": "June 18",
                    "date": "2018-06-18",
                    "range": false,
                    "endDate": ""
                },
                {
                    "key": "ThirdRegistrationPeriod",
                    "dateDisplay": "June 18 - June 24",
                    "date": "2018-06-18",
                    "range": true,
                    "endDate": "2018-06-24"
                },
                {
                    "key": "FifthDay",
                    "dateDisplay": "June 22",
                    "date": "2018-06-22",
                    "range": false,
                    "endDate": ""
                },
                {
                    "key": "LastDropDayNotRecordedATerm",
                    "dateDisplay": "June 24",
                    "date": "2018-06-24",
                    "range": false,
                    "endDate": ""
                },
                {
                    "key": "CensusDay",
                    "dateDisplay": "June 29",
                    "date": "2018-06-29",
                    "range": false,
                    "endDate": ""
                },
                {
                    "key": "LastDropDayNotRecorded",
                    "dateDisplay": "July 1",
                    "date": "2018-07-01",
                    "range": false,
                    "endDate": ""
                },
                {
                    "key": "last_add_day",
                    "dateDisplay": "July 8",
                    "date": "2018-07-08",
                    "range": false,
                    "endDate": ""
                },
                {
                    "key": "last_add_day_summer_full",
                    "dateDisplay": "July 8",
                    "date": "2018-07-08",
                    "range": false,
                    "endDate": ""
                },
                {
                    "key": "last_add_day_summer_a",
                    "dateDisplay": "July 8",
                    "date": "2018-07-08",
                    "range": false,
                    "endDate": ""
                },
                {
                    "key": "LastDropDayATerm",
                    "dateDisplay": "July 8",
                    "date": "2018-07-08",
                    "range": false,
                    "endDate": ""
                },
                {
                    "key": "ATermLastDay",
                    "dateDisplay": "July 18",
                    "date": "2018-07-18",
                    "range": false,
                    "endDate": ""
                },
                {
                    "key": "BTermFirstDay",
                    "dateDisplay": "July 19",
                    "date": "2018-07-19",
                    "range": false,
                    "endDate": ""
                },
                {
                    "key": "last_add_day_summer_b",
                    "dateDisplay": "July 25",
                    "date": "2018-07-25",
                    "range": false,
                    "endDate": ""
                },
                {
                    "key": "LastDropDayNotRecordedBTerm",
                    "dateDisplay": "July 25",
                    "date": "2018-07-25",
                    "range": false,
                    "endDate": ""
                },
                {
                    "key": "LastDropDay",
                    "dateDisplay": "August 5",
                    "date": "2018-08-05",
                    "range": false,
                    "endDate": ""
                },
                {
                    "key": "LastDropDayBTerm",
                    "dateDisplay": "August 8",
                    "date": "2018-08-08",
                    "range": false,
                    "endDate": ""
                },
                {
                    "key": "LastDayOfClasses",
                    "dateDisplay": "August 17",
                    "date": "2018-08-17",
                    "range": false,
                    "endDate": ""
                },
                {
                    "key": "LastFinalExamDay",
                    "dateDisplay": "August 17",
                    "date": "2018-08-17",
                    "range": false,
                    "endDate": ""
                }
            ],
            "numericYear": 2018,
            "characterCode": "",
            "numericCode": 3
        },
        "20184": {
            "year": "2018",
            "code": "4",
            "id": "20184",
            "codeName": "Autumn",
            "name": "Autumn 2018",
            "qtrYearParam": "AUT+2018",
            "shortName": "AU 18",
            "shortNameFullYear": "AU 2018",
            "subTerms": [],
            "currentWeek": 0,
            "maxWeeks": 10,
            "academicCalendar": [
                {
                    "key": "RegistrationServicesStart",
                    "dateDisplay": "April 27",
                    "date": "2018-04-27",
                    "range": false,
                    "endDate": ""
                },
                {
                    "key": "FirstRegistrationPeriod",
                    "dateDisplay": "May 4 - June 17",
                    "date": "2018-05-04",
                    "range": true,
                    "endDate": "2018-06-17"
                },
                {
                    "key": "SecondRegistrationPeriod",
                    "dateDisplay": "June 18 - September 25",
                    "date": "2018-06-18",
                    "range": true,
                    "endDate": "2018-09-25"
                },
                {
                    "key": "FirstDay",
                    "dateDisplay": "September 26",
                    "date": "2018-09-26",
                    "range": false,
                    "endDate": ""
                },
                {
                    "key": "ThirdRegistrationPeriod",
                    "dateDisplay": "September 26 - October 2",
                    "date": "2018-09-26",
                    "range": true,
                    "endDate": "2018-10-02"
                },
                {
                    "key": "FifthDay",
                    "dateDisplay": "October 2",
                    "date": "2018-10-02",
                    "range": false,
                    "endDate": ""
                },
                {
                    "key": "CensusDay",
                    "dateDisplay": "October 5",
                    "date": "2018-10-05",
                    "range": false,
                    "endDate": ""
                },
                {
                    "key": "LastDropDayNotRecorded",
                    "dateDisplay": "October 9",
                    "date": "2018-10-09",
                    "range": false,
                    "endDate": ""
                },
                {
                    "key": "last_add_day",
                    "dateDisplay": "October 16",
                    "date": "2018-10-16",
                    "range": false,
                    "endDate": ""
                },
                {
                    "key": "LastDropDay",
                    "dateDisplay": "November 13",
                    "date": "2018-11-13",
                    "range": false,
                    "endDate": ""
                },
                {
                    "key": "LastDayOfClasses",
                    "dateDisplay": "December 7",
                    "date": "2018-12-07",
                    "range": false,
                    "endDate": ""
                },
                {
                    "key": "LastFinalExamDay",
                    "dateDisplay": "December 14",
                    "date": "2018-12-14",
                    "range": false,
                    "endDate": ""
                }
            ],
            "numericYear": 2018,
            "characterCode": "",
            "numericCode": 4
        },
        "20191": {
            "year": "2019",
            "code": "1",
            "id": "20191",
            "codeName": "Winter",
            "name": "Winter 2019",
            "qtrYearParam": "WIN+2019",
            "shortName": "WI 19",
            "shortNameFullYear": "WI 2019",
            "subTerms": [],
            "currentWeek": 5,
            "maxWeeks": 10,
            "academicCalendar": [
                {
                    "key": "RegistrationServicesStart",
                    "dateDisplay": "October 26",
                    "date": "2018-10-26",
                    "range": false,
                    "endDate": ""
                },
                {
                    "key": "FirstRegistrationPeriod",
                    "dateDisplay": "November 2 - November 18",
                    "date": "2018-11-02",
                    "range": true,
                    "endDate": "2018-11-18"
                },
                {
                    "key": "SecondRegistrationPeriod",
                    "dateDisplay": "November 19 - January 6",
                    "date": "2018-11-19",
                    "range": true,
                    "endDate": "2019-01-06"
                },
                {
                    "key": "FirstDay",
                    "dateDisplay": "January 7",
                    "date": "2019-01-07",
                    "range": false,
                    "endDate": ""
                },
                {
                    "key": "ThirdRegistrationPeriod",
                    "dateDisplay": "January 7 - January 13",
                    "date": "2019-01-07",
                    "range": true,
                    "endDate": "2019-01-13"
                },
                {
                    "key": "FifthDay",
                    "dateDisplay": "January 11",
                    "date": "2019-01-11",
                    "range": false,
                    "endDate": ""
                },
                {
                    "key": "CensusDay",
                    "dateDisplay": "January 18",
                    "date": "2019-01-18",
                    "range": false,
                    "endDate": ""
                },
                {
                    "key": "LastDropDayNotRecorded",
                    "dateDisplay": "January 20",
                    "date": "2019-01-20",
                    "range": false,
                    "endDate": ""
                },
                {
                    "key": "last_add_day",
                    "dateDisplay": "January 27",
                    "date": "2019-01-27",
                    "range": false,
                    "endDate": ""
                },
                {
                    "key": "LastDropDay",
                    "dateDisplay": "February 24",
                    "date": "2019-02-24",
                    "range": false,
                    "endDate": ""
                },
                {
                    "key": "LastDayOfClasses",
                    "dateDisplay": "March 15",
                    "date": "2019-03-15",
                    "range": false,
                    "endDate": ""
                },
                {
                    "key": "LastFinalExamDay",
                    "dateDisplay": "March 22",
                    "date": "2019-03-22",
                    "range": false,
                    "endDate": ""
                }
            ],
            "numericYear": 2019,
            "characterCode": "",
            "numericCode": 1
        },
        "20192": {
            "year": "2019",
            "code": "2",
            "id": "20192",
            "codeName": "Spring",
            "name": "Spring 2019",
            "qtrYearParam": "SPR+2019",
            "shortName": "SP 19",
            "shortNameFullYear": "SP 2019",
            "subTerms": [],
            "currentWeek": 0,
            "maxWeeks": 10,
            "academicCalendar": [
                {
                    "key": "RegistrationServicesStart",
                    "dateDisplay": "February 8",
                    "date": "2019-02-08",
                    "range": false,
                    "endDate": ""
                },
                {
                    "key": "FirstRegistrationPeriod",
                    "dateDisplay": "February 15 - March 3",
                    "date": "2019-02-15",
                    "range": true,
                    "endDate": "2019-03-03"
                },
                {
                    "key": "SecondRegistrationPeriod",
                    "dateDisplay": "March 4 - March 31",
                    "date": "2019-03-04",
                    "range": true,
                    "endDate": "2019-03-31"
                },
                {
                    "key": "FirstDay",
                    "dateDisplay": "April 1",
                    "date": "2019-04-01",
                    "range": false,
                    "endDate": ""
                },
                {
                    "key": "ThirdRegistrationPeriod",
                    "dateDisplay": "April 1 - April 7",
                    "date": "2019-04-01",
                    "range": true,
                    "endDate": "2019-04-07"
                },
                {
                    "key": "FifthDay",
                    "dateDisplay": "April 5",
                    "date": "2019-04-05",
                    "range": false,
                    "endDate": ""
                },
                {
                    "key": "CensusDay",
                    "dateDisplay": "April 12",
                    "date": "2019-04-12",
                    "range": false,
                    "endDate": ""
                },
                {
                    "key": "LastDropDayNotRecorded",
                    "dateDisplay": "April 14",
                    "date": "2019-04-14",
                    "range": false,
                    "endDate": ""
                },
                {
                    "key": "last_add_day",
                    "dateDisplay": "April 21",
                    "date": "2019-04-21",
                    "range": false,
                    "endDate": ""
                },
                {
                    "key": "LastDropDay",
                    "dateDisplay": "May 19",
                    "date": "2019-05-19",
                    "range": false,
                    "endDate": ""
                },
                {
                    "key": "LastDayOfClasses",
                    "dateDisplay": "June 7",
                    "date": "2019-06-07",
                    "range": false,
                    "endDate": ""
                },
                {
                    "key": "LastFinalExamDay",
                    "dateDisplay": "June 14",
                    "date": "2019-06-14",
                    "range": false,
                    "endDate": ""
                }
            ],
            "numericYear": 2019,
            "characterCode": "",
            "numericCode": 2
        },
        "20193": {
            "year": "2019",
            "code": "3",
            "id": "20193",
            "codeName": "Summer",
            "name": "Summer 2019",
            "qtrYearParam": "SUM+2019",
            "shortName": "SU 19",
            "shortNameFullYear": "SU 2019",
            "subTerms": [],
            "currentWeek": 0,
            "maxWeeks": 10,
            "academicCalendar": [
                {
                    "key": "RegistrationServicesStart",
                    "dateDisplay": "April 8",
                    "date": "2019-04-08",
                    "range": false,
                    "endDate": ""
                },
                {
                    "key": "FirstRegistrationPeriod",
                    "dateDisplay": "April 15 - May 22",
                    "date": "2019-04-15",
                    "range": true,
                    "endDate": "2019-05-22"
                },
                {
                    "key": "SecondRegistrationPeriod",
                    "dateDisplay": "May 23 - June 23",
                    "date": "2019-05-23",
                    "range": true,
                    "endDate": "2019-06-23"
                },
                {
                    "key": "FirstDay",
                    "dateDisplay": "June 24",
                    "date": "2019-06-24",
                    "range": false,
                    "endDate": ""
                },
                {
                    "key": "ThirdRegistrationPeriod",
                    "dateDisplay": "June 24 - June 30",
                    "date": "2019-06-24",
                    "range": true,
                    "endDate": "2019-06-30"
                },
                {
                    "key": "FifthDay",
                    "dateDisplay": "June 28",
                    "date": "2019-06-28",
                    "range": false,
                    "endDate": ""
                },
                {
                    "key": "LastDropDayNotRecordedATerm",
                    "dateDisplay": "June 30",
                    "date": "2019-06-30",
                    "range": false,
                    "endDate": ""
                },
                {
                    "key": "CensusDay",
                    "dateDisplay": "July 5",
                    "date": "2019-07-05",
                    "range": false,
                    "endDate": ""
                },
                {
                    "key": "LastDropDayNotRecorded",
                    "dateDisplay": "July 7",
                    "date": "2019-07-07",
                    "range": false,
                    "endDate": ""
                },
                {
                    "key": "last_add_day",
                    "dateDisplay": "July 14",
                    "date": "2019-07-14",
                    "range": false,
                    "endDate": ""
                },
                {
                    "key": "last_add_day_summer_full",
                    "dateDisplay": "July 14",
                    "date": "2019-07-14",
                    "range": false,
                    "endDate": ""
                },
                {
                    "key": "last_add_day_summer_a",
                    "dateDisplay": "July 14",
                    "date": "2019-07-14",
                    "range": false,
                    "endDate": ""
                },
                {
                    "key": "LastDropDayATerm",
                    "dateDisplay": "July 14",
                    "date": "2019-07-14",
                    "range": false,
                    "endDate": ""
                },
                {
                    "key": "ATermLastDay",
                    "dateDisplay": "July 24",
                    "date": "2019-07-24",
                    "range": false,
                    "endDate": ""
                },
                {
                    "key": "BTermFirstDay",
                    "dateDisplay": "July 25",
                    "date": "2019-07-25",
                    "range": false,
                    "endDate": ""
                },
                {
                    "key": "last_add_day_summer_b",
                    "dateDisplay": "July 31",
                    "date": "2019-07-31",
                    "range": false,
                    "endDate": ""
                },
                {
                    "key": "LastDropDayNotRecordedBTerm",
                    "dateDisplay": "July 31",
                    "date": "2019-07-31",
                    "range": false,
                    "endDate": ""
                },
                {
                    "key": "LastDropDay",
                    "dateDisplay": "August 11",
                    "date": "2019-08-11",
                    "range": false,
                    "endDate": ""
                },
                {
                    "key": "LastDropDayBTerm",
                    "dateDisplay": "August 14",
                    "date": "2019-08-14",
                    "range": false,
                    "endDate": ""
                },
                {
                    "key": "LastDayOfClasses",
                    "dateDisplay": "August 23",
                    "date": "2019-08-23",
                    "range": false,
                    "endDate": ""
                },
                {
                    "key": "LastFinalExamDay",
                    "dateDisplay": "August 23",
                    "date": "2019-08-23",
                    "range": false,
                    "endDate": ""
                }
            ],
            "numericYear": 2019,
            "characterCode": "",
            "numericCode": 3
        },
        "20194": {
            "year": "2019",
            "code": "4",
            "id": "20194",
            "codeName": "Autumn",
            "name": "Autumn 2019",
            "qtrYearParam": "AUT+2019",
            "shortName": "AU 19",
            "shortNameFullYear": "AU 2019",
            "subTerms": [],
            "currentWeek": 0,
            "maxWeeks": 10,
            "academicCalendar": [
                {
                    "key": "RegistrationServicesStart",
                    "dateDisplay": "May 3",
                    "date": "2019-05-03",
                    "range": false,
                    "endDate": ""
                },
                {
                    "key": "FirstRegistrationPeriod",
                    "dateDisplay": "May 10 - June 23",
                    "date": "2019-05-10",
                    "range": true,
                    "endDate": "2019-06-23"
                },
                {
                    "key": "SecondRegistrationPeriod",
                    "dateDisplay": "June 24 - September 24",
                    "date": "2019-06-24",
                    "range": true,
                    "endDate": "2019-09-24"
                },
                {
                    "key": "FirstDay",
                    "dateDisplay": "September 25",
                    "date": "2019-09-25",
                    "range": false,
                    "endDate": ""
                },
                {
                    "key": "ThirdRegistrationPeriod",
                    "dateDisplay": "September 25 - October 1",
                    "date": "2019-09-25",
                    "range": true,
                    "endDate": "2019-10-01"
                },
                {
                    "key": "FifthDay",
                    "dateDisplay": "October 1",
                    "date": "2019-10-01",
                    "range": false,
                    "endDate": ""
                },
                {
                    "key": "CensusDay",
                    "dateDisplay": "October 4",
                    "date": "2019-10-04",
                    "range": false,
                    "endDate": ""
                },
                {
                    "key": "LastDropDayNotRecorded",
                    "dateDisplay": "October 8",
                    "date": "2019-10-08",
                    "range": false,
                    "endDate": ""
                },
                {
                    "key": "last_add_day",
                    "dateDisplay": "October 15",
                    "date": "2019-10-15",
                    "range": false,
                    "endDate": ""
                },
                {
                    "key": "LastDropDay",
                    "dateDisplay": "November 12",
                    "date": "2019-11-12",
                    "range": false,
                    "endDate": ""
                },
                {
                    "key": "LastDayOfClasses",
                    "dateDisplay": "December 6",
                    "date": "2019-12-06",
                    "range": false,
                    "endDate": ""
                },
                {
                    "key": "LastFinalExamDay",
                    "dateDisplay": "December 13",
                    "date": "2019-12-13",
                    "range": false,
                    "endDate": ""
                }
            ],
            "numericYear": 2019,
            "characterCode": "",
            "numericCode": 4
        }
    }

};

module.exports = MockTermConstants;
